<template>
  <InfoLayout
    v-if="!isMobile"
    :current-path="reverseFull({ name: 'ethical_commission' })"
    :is-policy="false"
  >
    <template #title>
      {{ t('Этический комитет', options) }}
    </template>
    <template #content>
      <MainContent
        :ethical-commission-meetings="context.ethical_commission_meetings"
        :is-staff="!!context.request.user?.is_staff"
      />
    </template>
  </InfoLayout>
  <div v-else>
    <MainContent
      :ethical-commission-meetings="context.ethical_commission_meetings"
      :is-staff="!!context.request.user?.is_staff"
    />
  </div>
</template>

<script lang="ts" setup>
import { useContextStore, useURLStore } from 'src/store'
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/components/pages/info/ethical-commission/meetings/types'
import MainContent from 'src/components/pages/info/ethical-commission/meetings/components/MainContent/MainContent.vue'
import InfoLayout from 'src/layouts/info-pages/InfoLayout.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const { reverseFull } = useURLStore()
const isMobile = context.flavour === 'mobile'
</script>
